import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { API } from '../App';

const SOBER_OPTION = {
  slug: null,
  emoji: '🧊',
  name: 'None (Sober)',
  tagline: 'Clear-headed debate',
};

export default function AlteredStatePicker({ onSelect, selected }) {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/api/altered-states')
      .then(r => setStates(r.data.states || r.data || []))
      .catch(() => setStates([]))
      .finally(() => setLoading(false));
  }, []);

  const allOptions = [SOBER_OPTION, ...states];

  if (loading) {
    return (
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="h-24 bg-[#1A1A1A] border border-[#2A2A2A] animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3" data-testid="altered-state-picker">
      {allOptions.map((s, i) => {
        const isSelected = selected === s.slug;
        return (
          <motion.button
            key={s.slug || 'sober'}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.03, duration: 0.15 }}
            onClick={() => onSelect(isSelected && s.slug !== null ? null : s.slug)}
            className={`p-3 border text-center transition-colors ${
              isSelected
                ? 'border-[#FF4D00] bg-[#FF4D00]/10'
                : 'border-[#2A2A2A] hover:border-[#FF4D00]/30'
            }`}
            data-testid={`state-${s.slug || 'sober'}`}
          >
            <span className="text-2xl block mb-1">{s.emoji}</span>
            <span className="text-xs font-bold block text-[#F5F5F5]">{s.name}</span>
            <span className="text-[9px] text-[#A0A0A0] block mt-0.5">{s.tagline}</span>
          </motion.button>
        );
      })}
    </div>
  );
}
